export const SEARCH_PLACEHOLDER = '输入商标名/注册号/类别/关键词'

export const HOT_SEARCH_ITEMS = [
  { label: '25类服装', category: '25' },
  { label: '35类广告销售', category: '35' },
  { label: '29类食品', category: '29' },
  { label: '30类方便食品', category: '30' },
  { label: '43类餐饮', category: '43' }
]
